import { gt } from "$json";
/* a11y-errors:
 *
 * Provide more accessible error texts
 *
 * Supported languages: nl, en (partially)
 *
 * Author: Niels Giesen
 * Copyright 2018 Berkeley Bridge
 *
 */
(function ($) {
  var translations = {
    "You may now safely close this window": {
      nl: "Je kunt het venster nu sluiten"
    },
    "Your models": {
      nl: "Jouw modellen"
    },
    "Your sessions": {
      nl: "Jouw sessies"
    },
    "Error: No response from server, server probably down": {
      nl: "Fout: Server is tijdelijk buiten gebruik. Je moet je opnieuw aanmelden."
    },
    "Session has timed out. Please log in again.": {
      nl: "De sessie is afgelopen. Je moet je opnieuw aanmelden."
    },
    "Input required": {
      nl: "Je hebt nog niets ingevuld in dit verplichte veld.",
      en: "You haven't yet filled in this required field."
    },
    "Choice required": {
      nl: "Je hebt nog geen keuze gemaakt; dit is verplicht bij deze opties.",
      en: "You haven't yet selected any option; please make a choice (required)."
    },
    "Value has to lie between {minimum} and {maximum}": {
      nl: "Het getal in dit veld is kleiner dan {minimum} of groter dan {maximum}; dit is niet toegestaan. Voer een getal in tussen {minimum} en {maximum}.",
      en: "The Value has to lie between {minimum} and {maximum}."
    },
    "Date has to lie between {minimum} and {maximum}": {
      nl: "De datum in dit veld valt voor of na {minimum} en {maximum}; dit is niet toegestaan. Voer een datum in tussen {minimum} en {maximum}.",
      en: "Date has to lie between {minimum} and {maximum}."
    },
    "Negative number or zero expected": {
      nl: "Het getal in dit veld is niet 0 of lager dan 0; dit is niet toegestaan. Voer in: 0 of een getal lager dan 0 (voorbeelden: -4 of -55).",
      en: "Negative number or zero expected"
    },
    "Negative number expected": {
      nl: "Het getal in dit veld moet lager zijn dan 0, maar is het niet. Voer getal in onder 0 (voorbeelden: -4 of -55).",
      en: "Negative number expected"
    },
    "Value has to lie below {maximum}": {
      nl: "Het getal in dit veld moet lager zijn dan {maximum}, maar is dat niet. Voer een getal in lager dan {maximum+1}.",
      en: "Value has to lie below {maximum+1}"
    },
    "Positive number or zero expected": {
      nl: "Het getal in dit veld moet 0 zijn of hoger dan 0, maar is dat niet. Voer het getal 0 in of een hoger getal, bijvoorbeeld 3 of 222.",
      en: "Positive number or zero expected"
    },
    "Positive number expected": {
      nl: "Het getal in dit veld moet hoger dan 0 zijn, maar is dat niet. Voer een getal in hoger dan 0 (voorbeelden: 1 of 42).",
      en: "Positive number expected"
    },
    "Value has to lie above {minimum}": {
      nl: "Het getal in dit veld moet hoger zijn dan {minimum}, maar is dat niet. Voer een getal in hoger dan {minimum-1}.",
      en: "Value has to lie above {minimum-1}"
    },
    "A date after {maximum} is not allowed": {
      nl: "De datum die je hebt ingevoerd in dit veld ligt ná {maximum}; dit is niet toegestaan.",
      en: "A date after {maximum} is not allowed"
    },
    "A date before {minimum} is not allowed": {
      nl: "De datum die je hebt ingevoerd in dit veld ligt vóór {minimum}; dit is niet toegestaan.",
      en: "A date before {minimum} is not allowed"
    },
    "Invalid date": {
      nl: "Je hebt een ongeldige datum ingevoerd. Een geldige datum heeft het formaat dd-mm-jjjj.",
      en: "Invalid date"
    },
    "Text length exceeds the maximum of {maxlength} characters": {
      nl: "Deze tekst bevat meer dan het maximum aantal karakters {maxlength}.",
      en: "Text length exceeds the maximum of {maxlength} characters"
    },
    "Maximum allowed characters: {0}": {
      nl: "Deze tekst bevat meer dan het maximum aantal karakters {0}.",
      en: "Maximum allowed characters: {0}"
    }
  };

  $(function () {
    gt.addTranslations(translations);
  });
})(jQuery);
